import * as req from 'api/actions';
import * as c from './constant';

export const activateProfile = (id, payload, callback) =>
  req.update(
    c.ACTIVATE_PROFILE,
    `/api/v1/administrators/taxpayers/${id}/activate`,
    payload,
    callback,
    (res) => {
      const { message } = res.res;
      alert.success(message || 'Successfully Updated !');
      if (callback) callback();
    }
  );

export const changePassword = (id, payload, callback) =>
  req.update(
    c.CHANGE_PASSWORD,
    `/api/v1/administrators/taxpayers/${id}/change_password`,
    payload,
    callback,
    (res) => {
      const { message } = res.res;
      alert.success(message || 'Password Successfully Changed !');
      if (callback) callback();
    }
  );

export const getTransactionList = (payload = {}, callback) =>
  req.list(
    c.GET_TRANSACTION,
    '/api/v1/administrators/taxpayers',
    payload,
    callback
  );

export const getTransactions = (
  id,
  payload = {
    mobule_type: 'PSA',
    transaction_type: 'BIRTH CERTIFICATE',
  },
  callback
) =>
  req.list(
    c.GET_TRANSACTIONS,
    '/api/v1/administrators/transaction_histories',
    {
      ...payload,
      tax_payer_id: id,
      q: '',
    },
    callback
  );

export const getBirthcertificatesArchive = (payload = {}, callback) =>
  req.list(
    c.GET_BIRTH_ARCHIVE,
    '/api/v1/administrators/birth_certificates/transaction_histories',
    payload,
    callback
  );

export const showTransaction = (id, payload, callback) =>
  req.item(
    c.SHOW_TRANSACTION,
    `/api/v1/administrators/taxpayers/${id}`,
    payload,
    callback
  );

export const updateTransaction = (id, payload, callback) =>
  req.update(
    c.UPDATE_TRANSACTION,
    `/api/v1/administrators/transaction_histories/${id}`,
    payload,
    callback,
    (res) => {
      const { message } = res.res;
      alert.success(message || 'Successfully Updated !');
      if (callback) callback();
    }
  );

export const approveTransaction = (id, payload, callback) =>
  req.update(
    c.APPROVE_TRANSACTION,
    `/api/v1/administrators/transaction_histories/${id}`,
    payload,
    callback,
    (res) => {
      const { message } = res.res;
      alert.success(message || 'Successfully Updated !');
      if (callback) callback();
    }
  );

export const approveVerification = (id, payload, callback) =>
  req.update(
    c.APPROVE_VERIFICATION,
    `/api/v1/administrators/taxpayers/${id}/approve_verification`,
    payload,
    callback,
    (res) => {
      const { message } = res.res;
      alert.success(message || 'Successfully Approved !');
      if (callback) callback();
    }
  );

export const rejectVerification = (id, payload, callback) =>
  req.update(
    c.REJECT_VERIFICATION,
    `/api/v1/administrators/taxpayers/${id}/reject_verification`,
    payload,
    callback,
    (res) => {
      const { message } = res.res;
      alert.success(message || 'Successfully Rejected !');
      if (callback) callback();
    }
  );
  
export const startAssessment = (id, callback) =>
  req.update(
    c.START_ASSESSMENT,
    `/api/v1/administrators/transaction_histories/${id}/start_assessment`,
    callback,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const clearTransaction = () => req.setList(c.GET_TRANSACTION, []);

export const getSettings = (card_type, callback) =>
  req.item(c.GET_SETTINGS, `/api/v1/administrators/ohp_settings`, callback, {
    card_type,
  });

export const updatedHealthStatus = (id, payload, callback) =>
  req.update(
    c.UPDATE_TEST_STATUS,
    `/api/v1/administrators/occupational_health_permits/${id}`,
    payload,
    callback
  );

export const getRegionsList = (payload, callback) =>
  req.list(
    c.GET_REGION,
    '/api/v1/administrators/address/regions',
    payload,
    callback
  );

export const getProvinceList = (payload, callback) =>
  req.list(
    c.GET_PROVINCE,
    '/api/v1/administrators/address/provinces',
    payload,
    callback
  );

export const getMunicipalityList = (payload, callback) =>
  req.list(
    c.GET_MUNICIPALITIES,
    '/api/v1/administrators/address/municipalities',
    payload,
    callback
  );

export const getBarangayList = (payload, callback) =>
  req.list(
    c.GET_BARANGAYS,
    '/api/v1/administrators/address/barangays',
    payload,
    callback
  );

export const updateProfile = (id, payload, callback) =>
  req.update(
    c.UPDATE_PROFILE,
    `/api/v1/administrators/taxpayers/${id}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const createAccount = (payload, callback) =>
  req.create(
    c.CREATE_ACCOUNT,
    `/api/v1/administrators/taxpayers`,
    payload,
    callback
  );

export const changePin = (id, payload, callback) =>
  req.update(
    c.CHANGE_PIN,
    `/api/v1/administrators/taxpayers/${id}/change_pin`,
    payload,
    callback,
    (res) => {
      const { message } = res.res;
      alert.success(message || 'Pin Successfully Changed !');
      if (callback) callback();
    }
  );

export const validateOtp = (payload, callback) =>
  req.create(
    c.VALIDATE_OTP,
    '/api/v1/administrators/taxpayers/validate_otp',
    payload,
    callback,
  );

export const resendOtp = (payload, callback) =>
  req.create(
    c.RESEND_OTP,
    '/api/v1/administrators/taxpayers/resend_otp',
    payload,
    callback,
  );

export const updateValidateOtp = (id, payload, callback) =>
  req.create(
    c.UPDATE_VALIDATE_OTP,
    `/api/v1/administrators/taxpayers/${id}/validate_mobile_number`,
    payload,
    callback,
  );

export const resendUpdateValidateOtp = (id, payload, callback) =>
  req.item(
    c.RESEND_UPDATE_VALIDATE_OTP,
    `/api/v1/administrators/taxpayers/${id}/resend_mobile_number_otp`,
    payload,
    callback,
  );

export const updateMobileNumber = (id, payload, callback) =>
  req.update(
    c.UPDATE_MOBILE_NUMBER,
    `/api/v1/administrators/taxpayers/${id}/update_mobile_number`,
    payload,
    callback,
    (res) => {
      const { message } = res.res;
      alert.success(message || 'Mobile Number Successfully Updated!');
      if (callback) callback();
    }
  );

export const updateOtp = (id, payload, callback) =>
  req.create(
    c.UPDATE_OTP,
    `/api/v1/administrators/taxpayers/${id}/validate_mobile_number`,
    payload,
    callback,
  );

export const resendOtpMobile = (id, payload, callback) =>
  req.item(
    c.RESEND_OTP_MOBILE,
    `/api/v1/administrators/taxpayers/${id}/resend_mobile_number_otp`,
    payload,
    callback,
  );

export const updateEmail = (id, payload, callback) =>
  req.update(
    c.UPDATE_EMAIL,
    `/api/v1/administrators/taxpayers/${id}/update_email`,
    payload,
    callback,
    (res) => {
      const { message } = res.res;
      alert.success(message || 'Email Successfully Updated!');
      if (callback) callback();
    }
  );

export const updateOtpEmail = (id, payload, callback) =>
  req.create(
    c.UPDATE_OTP_EMAIL,
    `/api/v1/administrators/taxpayers/${id}/validate_email`,
    payload,
    callback,
  );

export const resendOtpEmail = (id, payload, callback) =>
  req.item(
    c.RESEND_OTP_EMAIL,
    `/api/v1/administrators/taxpayers/${id}/resend_email_otp`,
    payload,
    callback,
  );

export const getReportAccess = (payload, callback) =>
  req.create(
    c.GET_REPORT_ACCESS,
    '/api/v1/administrators/report_access_tokens',
    payload,
    callback
  );